import ApplicationController from "./application_controller";

export default class extends ApplicationController {

  applySpinner(event) {
    document.querySelector(`#${event.target.dataset.resultTableId}`).innerHTML = '';
    const spinner = document.querySelector('#table-spin-loader');
    spinner.classList.remove('vanish');
  }
}